import React from "react"
import { Helmet } from "react-helmet"

// import { StyledContainer } from "../Styled/Container"

import { Banner, Content, Gradient, Image, ImageContainer, Link, RichText, Section, Title, TextContainer } from "./RetirementMessageStyles"
import RetirementImage from "../../../public/images/retirement-image.jpg"

export const RetirementMessage = (): JSX.Element => (
  <>
    <Helmet>
      <title>CareCompare</title>
      <meta name="description" content="We are still out there looking for ways to support older Australians to make informed decisions." />
    </Helmet>
    <Section>
      <Banner>
        <ImageContainer>
          <Image alt={`CareCompare is offline`} src={RetirementImage} />
        </ImageContainer>
        <Gradient />
        <TextContainer>
          <Content>
            <Title>We are sorry, CareCompare is offline.</Title>
            <RichText>We are still out there looking for ways to support older Australians to make informed decisions.</RichText>
            <RichText>
              If there is anything you would like to chat about please reach out to us on{" "}
              <Link href="mailto:contact@carecompare.com.au" title="Contact Us">
                contact@carecompare.com.au
              </Link>
            </RichText>
          </Content>
        </TextContainer>
      </Banner>
    </Section>
  </>
)
